import React from "react";
import AdminSidebar from "./Components/MenuSidebar";
import AdminHeader from "./../Admin/Components/AdminHeader";
import PanelWrapper from "./PanelWrapper";

const NotificationList = () => {
  return (
    <PanelWrapper>
      <div className="container">
        <div className="page-header">
          <h2>Settings</h2>
        </div>

        <div className="page-content-card">Coming Soon..</div>
      </div>
    </PanelWrapper>
  );
};

export default NotificationList;
